module.exports = __webpack_public_path__ + "static/media/logo-1.93c0d668.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-1.svg
// module id = 821
// module chunks = 0